import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

export default class Scrollspy {
    constructor(element) {
        this.element = element;

        gsap.registerPlugin(ScrollTrigger)

        gsap.from(this.element, {
            scrollTrigger: {
                start: 'top-=75 center',
                end: 'bottom+=75 center',
                trigger: this.element,
                toggleClass: 'active'
            }
        });
    }
}
